<template>
  <div class="caDailog"
       :class="langFlag ?'enPage':''">
    <div class="caDailog_iiner">
      <i class="cad_close"
         @click="closeMu()"></i>
      <span class="meue_lag"
            @click='changeLang()'>{{lang}}</span>
      <!-- <div class="caDailog_hd">
        <span class="caDailog_hd_li"
              :class="tabIndex == 0?'active':''"
              @click="menuChange(0)">{{langFlag ?'JOURNAL':'日志 '}}</span>
        <span class="caDailog_hd_li"
              :class="tabIndex == 1?'active':''"
              @click="menuChange(1)">{{langFlag ?'PROJECT':'作品案例 '}}</span>
        <span class="caDailog_hd_li"
              :class="tabIndex == 2?'active':''"
              @click="menuChange(2)">{{langFlag ?'ABOUT':'关于合恣 '}}</span>
      </div> -->
      <div class="muLogo">
        <img src="~@/assets/image/svg/Top Logo_white.svg"
             class="muLogo_img" />
      </div>
      <div class="mobMuTab">
        <span class="caDailog_hd_li"
              :class="tabIndex == 0?'active':''"
              @click="Torz(2)">{{langFlag ?'JOURNAL':'日志 '}}</span>
        <span class="caDailog_hd_li"
              :class="tabIndex == 1?'active':''"
              @click="Tosysj(0)">{{langFlag ?'PROJECT':'作品案例 '}}</span>
        <span class="caDailog_hd_li"
              :class="tabIndex == 2?'active':''"
              @click="toAbout()">{{langFlag ?'ABOUT':'关于合恣 '}}</span>
      </div>
      <!-- <div class="
              caDailog_bd">
          <div class="caDailog_item"
               v-show="tabIndex== 0">
            <div class="cad_sroll">
              <p class="cad_sroll_p"
                 v-for="item in joList"
                 :key="'joList' +item.id"
                 @click="toGoodLink(item)">{{item.title}}</p>
            </div>
          </div>
          <div class="caDailog_item "
               v-show="tabIndex== 1">
            <div class="cad_sroll">
              <p class="cad_sroll_p"
                 v-for="item in zpList"
                 :key="'zpList' +item.id"
                 @click="workShow(item.content)">{{item.title}}</p>
            </div>
          </div>

      </div> -->
    </div>
    <p class="caDailog_pp">Copyright © 2021 Hezi Design All Rights Reserved</p>
    <!-- 作品案例 -->
    <!-- <transition name="fade-fade">
      <wks v-show="workFlag"
           @closeWork="closeWork"
           :swiperData="swiperData"
           :sildeIndex="sildeIndex"></wks>
    </transition> -->
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import wks from '../views/works.vue'
export default {
  name: '',
  data() {
    return {
      workFlag: false,
      tabIndex: 0,
      joList: [],
      zpList: [],
      sildeIndex: 1,
      swiperData: [],
    }
  },
  props: ['muneFlag', 'muneIndex'],
  components: { wks },
  watch: {
    langFlag(val) {
      console.log('中英文的值', val)
      this.news2()
      this.project2()
    },
    muneIndex(val) {
      if (val == 0) {
        this.tabIndex = 0
      }
    },
  },
  mounted() {
    this.news2()
    this.project2()
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  methods: {
    toAbout() {
      this.$router.push({
        name: 'ab',
        // query: {
        //   type: type,
        // },
      })
    },
    Tosysj() {
      this.$router.push({
        name: 'zp',
        // query: {
        //   type: type,
        // },
      })
    },
    Torz() {
      this.$router.push({
        name: 'rz',
        // query: {
        //   type: type,
        // },
      })
    },
    //作品案例
    workShow(data) {
      this.$router.push({
        name: 'wks',
        query: {
          data: data,
        },
      })
      // this.sildeIndex = 0
      // this.swiperData = data
      // // this.mySwiper.slideTo(0, 1, false)
      // this.workFlag = true

      console.log('wrk', this.workFlag)
    },
    closeWork() {
      this.workFlag = false
      this.sildeIndex = 1
      console.log('wrk', this.workFlag)
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? '中' : 'EN')
      console.log('语言', this.langFlag)
    },
    menuChange(index) {
      this.tabIndex = index
      if (index == 2) {
        this.$emit('closeMu', false)
        this.$router.push({
          name: 'ab',
        })
      }
    },
    closeMu() {
      this.$emit('closeMu', false)
    },
    //去日志详情页
    toGoodLink(info) {
      //url 为空,就是跳以前的页面
      // if (!!info.url) {
      //   // window.location.href = info.url
      //   window.open(info.url, '_blank')
      // } else {
      //   this.$router.push({
      //     name: 'journal',
      //     query: {
      //       newsId: info.id,
      //     },
      //   })
      // }
      this.$emit('closeMu', false)
      this.$router.replace({
        name: 'rz',
        query: {
          id: info.id,
        },
      })
    },
    //所有日志
    news2() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'newsCate',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            this.joList = response.data
          }
        })
        .catch(function (error) {})
    },
    //所有项目
    project2() {
      let that = this
      let type = 'CN'
      if (this.langFlag) {
        //英文
        type = 'EN'
      }
      let data = this.$post(
        'project2',
        that.$qs.stringify({
          type: type,
        })
      )
        .then((response) => {
          if (response.code == 1) {
            this.zpList = response.data
          }
        })
        .catch(function (error) {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/menu.vue